function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { ADD_CIRCLE__24 } from '@homeaway/svg-defs';
import { SVGIcon } from '@homeaway/react-svg';
import Container from '../Container/Container';
import "./DoDont.css";
export default function Dont(props) {
  var children = props.children,
      _props$title = props.title,
      title = _props$title === void 0 ? "Don't" : _props$title,
      rest = _objectWithoutProperties(props, ["children", "title"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: "Dont"
  }, rest), /*#__PURE__*/React.createElement(Container, {
    dont: true
  }, /*#__PURE__*/React.createElement("h4", {
    className: "Dont__header"
  }, /*#__PURE__*/React.createElement(SVGIcon, {
    className: "Dont__icon text-danger",
    inlineFlex: true,
    markup: ADD_CIRCLE__24
  }), title)), children);
}
//# sourceMappingURL=Dont.js.map